import { Index } from "components/GetOffer/Index";

export const GetOffer = () => {
  return <Index />;
};
